var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4548Fog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300.4 232.8",
    style: {
      enableBackground: "new 0 0 300.4 232.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2,17.8c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9h172.9c4.9,0,8.9,4,8.9,8.9s-4,8.9-8.9,8.9H63.2z M63.2,232.8 c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9h172.9c4.9,0,8.9,4,8.9,8.9s-4,8.9-8.9,8.9H63.2z M63.2,125.3c-4.9,0-8.9-4-8.9-8.9 s4-8.9,8.9-8.9h172.9c4.9,0,8.9,4,8.9,8.9s-4,8.9-8.9,8.9H63.2z M147.4,179.6c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9h144.1 c4.9,0,8.9,4,8.9,8.9s-4,8.9-8.9,8.9H147.4z M8.9,179.6c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9h88.7c4.9,0,8.9,4,8.9,8.9 s-4,8.9-8.9,8.9H8.9z M8.9,72.1c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9H153c4.9,0,8.9,4,8.9,8.9s-4,8.9-8.9,8.9H8.9z M202.8,72.1 c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9h88.7c4.9,0,8.9,4,8.9,8.9s-4,8.9-8.9,8.9H202.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4548Fog);
export default __webpack_public_path__ + "static/media/45_48_fog.78d105f56b7ad94c17822ce11135a7dc.svg";
export { ForwardRef as ReactComponent };